import { Provider } from '@angular/core';

import { CommentRepositoryImpl } from '@app/data/repositories/comment/comment.repository';
import { COMMENT_REPOSITORY } from '@app/domain/repositories/comment.repository.contract';

export const commentRepositoryProvider: Provider = {
  provide: COMMENT_REPOSITORY,
  useClass: CommentRepositoryImpl
};
